import React from 'react';
import Computer from '@mui/icons-material/Computer';
import Assessment from '@mui/icons-material/Assessment';
import { Configs } from './components/configs';
import { Vms } from './components/vms';
import { LabDetail } from './components/LabDetail';

interface RouteType {
  path: string;
  name: string;
  icon: any;
  component: React.ComponentType<any>;
  layout: string;
}

const dashboardRoutes: RouteType[] = [
  {
    path: '/lab',
    name: 'Lab Config',
    icon: Computer,
    component: Configs,
    layout: '/admin'
  },
  {
    path: '/vms',
    name: 'VMs',
    icon: Computer,
    component: Vms,
    layout: '/admin'
  },
  {
    path: '/labdetail',
    name: 'Lab Details',
    icon: Assessment,
    component: LabDetail,
    layout: '/admin'
  },
];

export default dashboardRoutes;
